<style lang="scss">
.z-open-hours {
    display: flex;
    flex-wrap: wrap;
    .z-open-daynum {
        width: 100%;
        margin-bottom: 1em;
        position:relative;
    }
    &.columns .z-open-daynum {
        width: auto;
        min-width: calc(25% - 30px);
        margin-right: 30px;

    }
    .z-open-dayname {
        width: 80px;
        font-size: .8em;
        text-transform: uppercase;
    }
    &.highlight .z-open-daynum.today {
        color:#333;
        padding: 4px 9px;
        margin: -5px 40px 1em -10px !important;
        border: solid 1px #eee;
        border-radius: 10px;
        background: #f5f5f5;
        box-shadow: 0 1px 3px rgba(0, 0, 0, .15),
            0 3px 9px rgba(0, 0, 0, .1),
            0 9px 27px rgba(0, 0, 0, .05);
        &:before {
            content:'';
            position:absolute;
            right:-20px; top:-10px;
            width: 50px;
            height:0;
            border:solid 15px transparent;
            border-bottom-color:rgba(0,0,0,.5);
            transform:rotate(45deg);
        }
        &:after {
            content: attr(data-today-text);
            text-transform: uppercase;
            display:block;
            color:white;
            transform:rotate(45deg);
            position:absolute;
            width: 50px;
            text-align:center;
            line-height:15px;
            height:15px;
            right:-15px;
            top:4px;
            font-size: 9px;
            font-weight:bold;
        }
    }
}
</style>
<template>
    <div class="z-open-hours" :class="{columns : multicol, highlight : showtoday}">
        <div class="z-open-daynum day-1" :class="{today : isToday(1)}" v-if="day1" :data-today-text="$translate('Today')">
            <div class="z-open-dayname">{{$translate('Monday')}}</div>
            <div class="z-open-hours">{{day1}}</div>
        </div>
        <div class="z-open-daynum day-2" :class="{today : isToday(2)}" v-if="day2" :data-today-text="$translate('Today')">
            <div class="z-open-dayname">{{$translate('Tuesday')}}</div>
            <div class="z-open-hours">{{day2}}</div>
        </div>
        <div class="z-open-daynum day-3" :class="{today : isToday(3)}" v-if="day3" :data-today-text="$translate('Today')">
            <div class="z-open-dayname">{{$translate('Wednesday')}}</div>
            <div class="z-open-hours">{{day3}}</div>
        </div>
        <div class="z-open-daynum day-4" :class="{today : isToday(4)}" v-if="day4" :data-today-text="$translate('Today')">
            <div class="z-open-dayname">{{$translate('Thursday')}}</div>
            <div class="z-open-hours">{{day4}}</div>
        </div>
        <div class="z-open-daynum day-5" :class="{today : isToday(5)}" v-if="day5" :data-today-text="$translate('Today')">
            <div class="z-open-dayname">{{$translate('Friday')}}</div>
            <div class="z-open-hours">{{day5}}</div>
        </div>
        <div class="z-open-daynum day-6" :class="{today : isToday(6)}" v-if="day6" :data-today-text="$translate('Today')">
            <div class="z-open-dayname">{{$translate('Saturday')}}</div>
            <div class="z-open-hours">{{day6}}</div>
        </div>
        <div class="z-open-daynum day-7" :class="{today : isToday(7)}" v-if="day7" :data-today-text="$translate('Today')">
            <div class="z-open-dayname">{{$translate('Sunday')}}</div>
            <div class="z-open-hours">{{day7}}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'zoezi-open-hours',
    zoezi: {
        title: 'Opening hours',
        icon: 'mdi-clock'
    },
    props: {
        multicol: {
            title: 'Multiple columns',
            type: Boolean,
            default: false
        },
        showtoday: {
            title: 'Highlight today',
            type: Boolean,
            default: true
        },
        day1: {
            title: 'Monday',
            type: String,
            default: '08:00 - 17:00'
        },
        day2: {
            title: 'Tuesday',
            type: String,
            default: '08:00 - 17:00'
        },
        day3: {
            title: 'Wednesday',
            type: String,
            default: '08:00 - 17:00'
        },
        day4: {
            title: 'Thursday',
            type: String,
            default: '08:00 - 17:00'
        },
        day5: {
            title: 'Friday',
            type: String,
            default: '08:00 - 17:00'
        },
        day6: {
            title: 'Saturday',
            type: String,
            default: () => window.$translate('Closed')
        },
        day7: {
            title: 'Sunday',
            type: String,
            default: () => window.$translate('Closed')
        }
    },

    methods: {
        isToday(daynum) {
            daynum = daynum == 7 ? 0 : daynum;
            let today = new Date();
            let todaynum = today.getDay();
            return daynum == todaynum;
        }
    }
}
</script>
